import { ETxnFilterSectionKeys } from "../interfaces/Reports/iTransactionHistory";
import { EmptyValidation, ReportsEnum } from "@domains/utils/commonText";
import { EmptyIcon } from "../action-interfaces/Reports/HoldingReport";
import { ReportName, ReportType, } from "@domains/aggregates/interfaces/Reports/iHoldingReport";
import { Filters, SortData, } from "@domains/aggregates/interfaces/Reports/iReportsCommon";
import { ESortOrder } from "@domains/utils/sort";
import { AssetCategory, NuvamaAssets } from "@domains/aggregates/interfaces/Reports/iPNLReport";
import { ERevampReportReducers } from "../action-interfaces/Reports/common/CommonReportInterfaces";
import { SearchPagination } from "@domains/useCases/Reports/TransactionHistory/SearchPagination";
class TransactionHistory {
    constructor(action, usecase, sendEmailReports, downloadPDFReports, downloadExcelReports, TransactionHistoryCommonUseCase) {
        this.action = action;
        this.usecase = usecase;
        this.sendEmailReports = sendEmailReports;
        this.downloadPDFReports = downloadPDFReports;
        this.downloadExcelReports = downloadExcelReports;
        this.TransactionHistoryCommonUseCase = TransactionHistoryCommonUseCase;
        this.initFilterState = new Map([
            [ETxnFilterSectionKeys.actionFilter, new Filters(ETxnFilterSectionKeys.actionFilter, [
                    {
                        title: "Approximated/Editable Transactions",
                        key: "true",
                        selected: false,
                    },
                    { title: "Buy Transactions", key: "Buy", selected: false },
                    { title: "Sell Transactions", key: "Sell", selected: false },
                ], "Filter By")], [
                ETxnFilterSectionKeys.assetFilter, new Filters(ETxnFilterSectionKeys.assetFilter, [
                    { title: NuvamaAssets.get(AssetCategory.Equity).display, key: NuvamaAssets.get(AssetCategory.Equity).value, selected: false },
                    { title: NuvamaAssets.get(AssetCategory.FixedIncome).display, key: NuvamaAssets.get(AssetCategory.FixedIncome).value, selected: false },
                    { title: NuvamaAssets.get(AssetCategory.Derivatives).display, key: NuvamaAssets.get(AssetCategory.Derivatives).value, selected: false },
                    { title: NuvamaAssets.get(AssetCategory.ManagedPortfolio).display, key: NuvamaAssets.get(AssetCategory.ManagedPortfolio).value, selected: false },
                    { title: NuvamaAssets.get(AssetCategory.Commodity).display, key: NuvamaAssets.get(AssetCategory.Commodity).value, selected: false },
                    { title: NuvamaAssets.get(AssetCategory.RealEstate).display, key: NuvamaAssets.get(AssetCategory.RealEstate).value, selected: false },
                ], "Asset Filters"),
            ], [
                ETxnFilterSectionKeys.txnTypeFilter, new Filters(ETxnFilterSectionKeys.txnTypeFilter, [
                    { title: "Adjustment Entry", key: "Adjustment Entry", selected: false },
                    { title: "Corporate Action", key: "Corporate Action", selected: false },
                    { title: "Off Market", key: "Off Market", selected: false },
                    { title: "Opening Balance", key: "Opening Balance", selected: false },
                    { title: "Others", key: "Others", selected: false },
                    { title: "Primary Market", key: "Primary Market", selected: false },
                ], "Transaction Type Filters")
            ]
        ]);
        this.filterState = this.initFilterState;
        this.paginationFilterstate = [];
        this.searchState = "";
        this.isSummarize = false;
        this.sortState = new SortData("", "", ESortOrder.UNCHANGED);
        this.transactionHistoryInitData = {
            totalRecords: 0,
            numberOfPages: 0,
            pageSize: 0,
            transactionList: [],
        };
        this.dateTimeTransactionGetAPI = null;
        this.emailList = [];
        this.allTxns = {
            totalRecords: 0,
            numberOfPages: 0,
            pageSize: 0,
            transactionList: [],
        };
        this.updateAllTxnInRedux = (response) => {
            if (!(response === null || response === void 0 ? void 0 : response.done)) {
                //done =true , pages are over ,
                this.action.transactionHistory.getAllTransactionHistory({
                    numberOfPages: this.allTxns.numberOfPages,
                    pageSize: this.allTxns.pageSize,
                    totalRecords: this.allTxns.totalRecords,
                    transactionList: (response === null || response === void 0 ? void 0 : response.data) ? [...response === null || response === void 0 ? void 0 : response.data] : [],
                }, ERevampReportReducers.TRANSACTION_HISTORY);
            }
        };
        /**
         * @method setSearchTextInRedux  it is used for debouncing  don't change
         * @param searchState
         */
        this.setSearchTextInRedux = (searchState) => {
            this.searchState = searchState;
            this.action.transactionHistory.setSearchData(searchState, ERevampReportReducers.TRANSACTION_HISTORY);
        };
    }
    resetFilterAndSearch() {
        this.filterState = this.initFilterState;
        this.searchState = "";
        this.paginationFilterstate = [];
        this.action.transactionHistory.setFilterData(this.initFilterState, ERevampReportReducers.TRANSACTION_HISTORY);
        this.action.transactionHistory.setSearchData("", ERevampReportReducers.TRANSACTION_HISTORY);
        this.getNewSearchPagination([]);
    }
    saveAllTHdata(allTransactionHistoryData) {
        this.allTxns = allTransactionHistoryData;
        this.action.transactionHistory.getAllTransactionHistory(allTransactionHistoryData, ERevampReportReducers.TRANSACTION_HISTORY);
        this.action.transactionHistory.allEditableTxns(allTransactionHistoryData.transactionList.filter((x) => x.editable === true), ERevampReportReducers.TRANSACTION_HISTORY);
        this.getNewSearchPagination(allTransactionHistoryData.transactionList);
        // Initially in view show 10 records for all txns
        this.getFilteredTHReportData(this.filterState);
    }
    getAllTransactionHistory(req, isDesktop) {
        // needs to confirm dateTimeTransactionGetAPI T-1?
        this.dateTimeTransactionGetAPI = new Date();
        this.action.transactionHistory.allTransactionHistoryLoader(true, ERevampReportReducers.TRANSACTION_HISTORY);
        this.action.transactionHistory.allTransactionHistoryHideError(ERevampReportReducers.TRANSACTION_HISTORY);
        this.saveAllTHdata(this.transactionHistoryInitData);
        this.action.transactionHistory.clear(ERevampReportReducers.TRANSACTION_HISTORY);
        this.usecase.transactionHistory.execute({
            onSuccess: (data) => {
                var _a, _b;
                const emptyValidation = EmptyValidation[EmptyIcon.EMPTY][ReportsEnum.TXN];
                this.setNoDataMessage(emptyValidation, (_b = (_a = data === null || data === void 0 ? void 0 : data.transactionList) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0);
                this.saveAllTHdata(data);
                this.action.transactionHistory.allTransactionHistoryLoader(false, ERevampReportReducers.TRANSACTION_HISTORY);
            },
            onError: (error) => {
                this.action.transactionHistory.allTransactionHistoryError({ error: error, isOpen: true }, ERevampReportReducers.TRANSACTION_HISTORY);
                this.action.transactionHistory.allTransactionHistoryLoader(false, ERevampReportReducers.TRANSACTION_HISTORY);
            },
        }, req);
    }
    async downloadAndSendTHReport(email, download) {
        let emailPayload = null, downloadPayload = null;
        if (email) {
            emailPayload = {
                reportName: ReportName.TRANSACTIONHISTORY,
                reportType: email.reportType,
                scripIdentifier: email.scripIdentifier,
                emailIds: email.emailIds,
                fromDate: email.fromDate,
                toDate: email.toDate,
            };
            if (email === null || email === void 0 ? void 0 : email.isPwdProtected)
                emailPayload.isPwdProtected = email.isPwdProtected;
        }
        if (download) {
            downloadPayload = {
                fromDate: download.fromDate,
                toDate: download.toDate,
                scripIdentifier: download.scripIdentifier,
                reportName: ReportName.TRANSACTIONHISTORY,
                reportType: download.reportType,
            };
            if (download === null || download === void 0 ? void 0 : download.isPwdProtected)
                downloadPayload.isPwdProtected = download.isPwdProtected;
        }
        try {
            if (email && download) {
                const emailResult = await this.sendTransactionHistoryEmail(emailPayload);
                const downloadResult = await this.downloadTransactionHistory(downloadPayload);
                return emailResult && downloadResult;
            }
            else if (email)
                return await this.sendTransactionHistoryEmail(emailPayload);
            else if (download)
                return await this.downloadTransactionHistory(downloadPayload);
            throw false;
        }
        catch (error) {
            throw false;
        }
    }
    async downloadTransactionHistory(req) {
        if (req.reportType == ReportType.PDF)
            return await this.downloadTHHelper(this.downloadPDFReports, req);
        return await this.downloadTHHelper(this.downloadExcelReports, req);
    }
    async downloadTHHelper(DType, downloadPayload) {
        return new Promise((resolve, reject) => {
            DType.execute({
                onSuccess: (data) => {
                    resolve(data);
                },
                onError: (error) => {
                    reject(false);
                },
            }, downloadPayload);
        });
    }
    async sendTransactionHistoryEmail(req) {
        this.emailList = req.emailIds;
        return new Promise((resolve, reject) => {
            this.sendEmailReports.execute({
                onSuccess: (data) => {
                    resolve(data);
                },
                onError: (error) => {
                    reject(false);
                },
            }, req);
        });
    }
    getApproximateTransactions(req) {
        return new Promise((resolve, reject) => {
            this.usecase.approximateTxns.execute({
                onSuccess: (data) => {
                    resolve(data);
                },
                onError: (error) => {
                    reject(error);
                },
            }, req);
        });
    }
    saveSortedTxnHistory(sortData, sortRecord, sortedData) {
        this.action.transactionHistory.setSortData({
            sortState: sortData,
            sortRecord: sortRecord,
        }, ERevampReportReducers.TRANSACTION_HISTORY);
        this.getNewSearchPagination(sortedData.transactionList);
        this.getFilteredTHReportData(this.filterState);
    }
    clearAllFilters() {
        this.filterState = this.initFilterState;
        this.action.transactionHistory.setFilterData(this.initFilterState, ERevampReportReducers.TRANSACTION_HISTORY);
        this.getFilteredTHReportData(this.filterState);
    }
    clearCommonMessage() {
        this.action.transactionHistory.clear(ERevampReportReducers.TRANSACTION_HISTORY);
    }
    /**
     *
     * @returns Whether there is any selected filter or not
     */
    detectSelectedFilter() {
        return Array.from(this.filterState.values())
            .some(filter => filter.filters.some(item => item.selected));
    }
    getNewSearchPagination(data) {
        //create new instance when there is change in sequence in data OR change in data length
        this.searchPagination = new SearchPagination([...data], "searchValue");
    }
    async getAlltxnDataNextpage() {
        //call for 2nd page
        return this.searchPagination.getNextPage().then((response) => {
            this.updateAllTxnInRedux(response);
            return response === null || response === void 0 ? void 0 : response.done;
        });
    }
    setNoDataMessage(emptyValidation, dataLength) {
        if (dataLength === 0) {
            this.action.transactionHistory.addMsg(emptyValidation.message, true, emptyValidation.icon, ERevampReportReducers.TRANSACTION_HISTORY);
        }
        else {
            this.action.transactionHistory.addMsg("", false, "", ERevampReportReducers.TRANSACTION_HISTORY);
        }
    }
    searchThroughTHReportMob(searchState) {
        const emptyValidation = EmptyValidation[EmptyIcon.SEARCH_NEW];
        this.initializeSearchFilterGenerator(searchState, this.paginationFilterstate, emptyValidation);
    }
    initializeSearchFilterGenerator(searchState, paginationFilterstate, emptyValidation) {
        if (this.searchPagination) {
            this.searchPagination.newSearchAndFilter(searchState, paginationFilterstate, 10).then((response) => {
                const transactionList = (response === null || response === void 0 ? void 0 : response.data) || [];
                this.setNoDataMessage(emptyValidation, transactionList.length);
                this.updateAllTxnInRedux(response);
            });
        }
    }
    async getFilteredTHReportData(filterState) {
        this.filterState = filterState;
        let paginationFilterState = [];
        const createFilterState = (keys, filters) => {
            const values = filters.filter(f => f.selected).map(f => f.key);
            return values.length ? { keys, values } : null;
        };
        this.action.transactionHistory.setFilterData(filterState, ERevampReportReducers.TRANSACTION_HISTORY);
        // searching asset code into edelweissProductShortCode , which is wrong,  should be searhed in edelweissTabShortCode
        const assetCodeFilterState = createFilterState(["edelweissTabShortCode"], filterState.get(ETxnFilterSectionKeys.assetFilter).filters);
        const editableFilterState = createFilterState(["filterFlags", "editable"], [filterState.get(ETxnFilterSectionKeys.actionFilter).filters[0]]);
        const actionFilterState = createFilterState(["action"], filterState.get(ETxnFilterSectionKeys.actionFilter).filters.slice(1));
        const txnFlagFilterState = createFilterState(["txnFlag"], filterState.get(ETxnFilterSectionKeys.txnTypeFilter).filters);
        [assetCodeFilterState, editableFilterState, actionFilterState, txnFlagFilterState]
            .forEach(state => state && paginationFilterState.push(state));
        this.paginationFilterstate = paginationFilterState;
        const emptyValidation = EmptyValidation[EmptyIcon.FILTER];
        this.initializeSearchFilterGenerator(this.searchState, this.paginationFilterstate, emptyValidation);
    }
}
export default TransactionHistory;
